import ListItem from './ListItem'

export default class ListPage {
  constructor({
    page = 1,
    current_page = 1,
    hasNextPage = true,
    hasPrevPage = false,
    items = [],
    offset = 0,
    last_page = null,
    per_page = 20,
    to = 20,
    totalCount = 0
  }) {
    this.page = page
    this.current_page = current_page
    this.hasNextPage = hasNextPage
    this.hasPrevPage = hasPrevPage
    this.offset = offset
    this.last_page = last_page
    this.per_page = per_page
    this.to = to
    this.totalCount = totalCount
    this.items = items.map(
      item => new ListItem({ item, currentQuantity: item.quantity })
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/ListPage.js